export default {"src":"/_next/static/media/AboutUs_OurVision.6f79e1cf.svg","height":427,"width":480,"blurWidth":0,"blurHeight":0};